
import { WorldCountry } from '../types';
import { argentinaExpanded } from './argentinaExpansion';
import { chileExpanded } from './chileExpansion';
import { venezuelaExpanded } from './venezuelaExpansion';

// Expansión Fase 8 - Países de América del Sur
export const southAmericaExpansion3: WorldCountry[] = [
  argentinaExpanded,
  chileExpanded,
  venezuelaExpanded
];
